/** ISO 날짜(YYYY-MM-DD)부터 기준일까지 채워진 햇수. 아직 안 지난 달은 세지 않아요. */
export function fullYearsSince(iso: string, now: Date = new Date()): number {
  const from = new Date(`${iso}T00:00:00`)
  let years = now.getFullYear() - from.getFullYear()
  const beforeAnniversary =
    now.getMonth() < from.getMonth() || (now.getMonth() === from.getMonth() && now.getDate() < from.getDate())
  if (beforeAnniversary) years -= 1
  return Math.max(0, years)
}
